<script>
    import { beforeUpdate, onMount } from "svelte";
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();
    let papel, ctx, ancho;

    let coord = { x: 0, y: 0 };
    let paint = false;

    onMount(() => {
        ctx = papel.getContext("2d");
    });
    beforeUpdate(() => {
        if (papel) {
            papel.width = ancho / 2 < 500 ? ancho / 2 : 500;
            papel.height = ancho / 2 < 500 ? ancho / 2 : 500;
        }
    });

    function getPosition(event) {
        let cx =
            event.touches != undefined
                ? event.touches[0].clientX
                : event.clientX;
        let cy =
            event.touches != undefined
                ? event.touches[0].clientY
                : event.clientY;
        coord.x = cx - papel.offsetLeft;
        coord.y = cy - papel.offsetTop;
    }
    function startPainting(event) {
        paint = true;
        getPosition(event);
    }
    function stopPainting() {
        let data = papel.toDataURL();
        paint = false;
        dispatch("base", {
            data: data,
        });
    }
    function sketch(event) {
        if (!paint) return;
        ctx.beginPath();

        ctx.lineWidth = 3;

        // Sets the end of the lines drawn
        // to a round shape.
        ctx.lineCap = "round";

        ctx.strokeStyle = "black";

        // The cursor to start drawing
        // moves to this coordinate
        ctx.moveTo(coord.x, coord.y);

        // The position of the cursor
        // gets updated as we move the
        // mouse around.
        getPosition(event);

        // A line is traced from start
        // coordinate to this coordinate
        ctx.lineTo(coord.x, coord.y);

        // Draws the line.
        ctx.stroke();
    }
</script>

<style>
    canvas {
        outline: solid 1px rgba(0, 0, 0, 0.1);
        background: white;
    }
</style>

<svelte:window bind:innerWidth={ancho} />
<div class="col s12 center-align">
    <canvas
        bind:this={papel}
        on:mousedown={startPainting}
        on:touchend={stopPainting}
        on:touchmove={sketch}
        on:touchstart={startPainting}
        on:mouseup={stopPainting}
        on:mousemove={sketch} />
</div>
